import * as Sentry from "@sentry/browser";
import * as _ from "lodash";
import { GetUser } from "./UserFunctions";

export const sentryAPICatch = (error, url) => {
  const user = GetUser();
  Sentry.configureScope((scope) =>
    scope
      .setLevel("Error")
      .setUser({ email: _.get(user, "epost", "undefined") })
      .setExtra("Name", _.get(user, "namn", "undefined"))
      .setExtra("UserID", _.get(user, "id", "undefined"))
      .setExtra("Endpoint", url)
  );
  Sentry.showReportDialog(); //- If you want get users feedback on error (Displays dialog)
  return Sentry.captureException(error);
};
